import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getApiBaseUrl } from "../../config";

const baseQuery = fetchBaseQuery({
  baseUrl: getApiBaseUrl(),
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const user = getState().user?.currentUser;
    if (user?.id) {
      headers.set("userid", user.id);
    }
    return headers;
  },
});

export const tutorialApi = createApi({
  reducerPath: "tutorialApi",
  baseQuery,
  tagTypes: ["Tutorials"],
  endpoints: (builder) => ({
    getTutorials: builder.query({
      query: (processType) => {
        const params = processType ? `?processType=${processType}` : "";
        return `/tutorials${params}`;
      },
      providesTags: ["Tutorials"],
    }),
    getTutorialById: builder.query({
      query: (id) => `/tutorials/${id}`,
      providesTags: (result, error, id) => [{ type: "Tutorials", id }],
    }),
  }),
});

export const {
  useGetTutorialsQuery,
  useGetTutorialByIdQuery,
} = tutorialApi;